const withTitle = (Component, title) => {
    return (props) => { 
        return (
            <Component {...props} title={title}/>
        );
    };
};

export default withTitle;